import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Row, Col, Button } from 'react-bootstrap';

import EntityStateUpdater from 'component/EntityStateUpdater';

import { formStatusDispatchHelper, formReset } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';

import Breadcrumb from 'components/layout/Breadcrumb';
import Tabs from 'components/layout/Tabs';

import CmsElementData from 'components/layout/cms/CmsElementData';

import Entity from 'components/Entity';
import Data from 'components/Data';

import { entityMetaMapping } from 'js/constants';

import FormErrors from 'components/forms/FormErrors';

import DocMeta from 'components/DocMeta';
import { generateMetaTags } from 'helpers/metaTags';

class CmsElementDetails extends EntityStateUpdater {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      entityLoaded: false,
      entityChanged: false,
      cmsEditMode: false,
    };

    this.entity = new Entity();

    // if we get page data from the outside, we can pass it on to our data entity
    if (props.elementData) {
      this.entity.setData(props.elementData);
    }

    if (props.meta[entityMetaMapping.cmsElement] !== undefined && !props.meta[entityMetaMapping.cmsElement].pending) {
      this.entity.setMeta(props.meta, entityMetaMapping.cmsElement);
    }

    if (this.entity.getDataLoaded() && this.entity.getMetaLoaded()) {
      this.state = {
        ...this.state,
        entityLoaded: true,
        entity: this.entity,
      };
    }
  }

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      meta,
      data,
      formStatus,
      doNotify,
    } = this.props;

    // item data was saved and there was no error
    if (prevProps.formStatus.pending && !formStatus.pending && !formStatus.hasError) {
      this.setState({ entityChanged: false });
      doNotify(1, messages.cms_element_saved);
    }

    if (prevProps.data.pending && !data.pending) {
      this.entity.setData(data.data);
      if (this.entity.getMetaLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }

    if (
      meta[entityMetaMapping.cmsElement] !== undefined &&
      !meta[entityMetaMapping.cmsElement].pending &&
      !this.entity.getMetaLoaded()
    ) {
      this.entity.setMeta(meta, entityMetaMapping.cmsElement);
      if (this.entity.getDataLoaded()) {
        this.setState({ entityLoaded: true, entity: this.entity });
      }
    }
  };

  formSubmit = e => {
    e.preventDefault();

    this.changeEntity(this.state.entity.validate(), () => {
      if (this.state.entity.isValid) {
        this.props.onSubmit(
          this.props.elementId ? this.props.elementId : this.props.match.params.elementId,
          this.state.entity.processedData
        );
      }
    });
  };

  getTabHeaderList = () => {
    const {
      intl: { messages },
    } = this.props;
    const result = [];

    result.push(messages.cms_element);

    return result;
  };

  getTabContentList = () => {
    const { formStatus } = this.props;
    const { entity, entityLoaded } = this.state;
    const result = [];

    result.push(
      <CmsElementData
        entityLoaded={entityLoaded}
        entity={entity}
        changeEntity={this.changeEntity}
        disabled={formStatus.pending}
      />
    );

    return result;
  };

  getTabKeepMounted = () => {
    const keepMounted = [];
    return keepMounted;
  };

  getBreadcrumb = () => {
    if (this.props.breadcrumb) {
      return this.props.breadcrumb;
    }

    const {
      intl: { messages },
      appIntl,
    } = this.props;
    const { entityLoaded, entity } = this.state;

    return (
      <Breadcrumb
        crumbs={[
          { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
          { link: appIntl.urlPrefix + 'account/settings', name: messages.settings },
          { link: appIntl.urlPrefix + 'account/settings/cmsElements', name: messages.cms_elements },
          { link: null, name: entityLoaded ? entity.getName() : null },
        ]}
        className="p-t-0"
      />
    );
  };

  render() {
    const {
      intl: { messages },
      data,
      formStatus,
    } = this.props;
    const { entity, entityLoaded } = this.state;

    let metaTitle = messages.cms_element;
    if (entityLoaded) {
      metaTitle += ' - ' + entity.getName();
    }

    return (
      <DocMeta tags={generateMetaTags(messages.meta.cms_element_details, metaTitle)}>
        <div class="padding-25 sm-padding-10">
          <Data
            dataName="cmsElement"
            url={
              '/api/dynamicelements/' +
              (this.props.elementId ? this.props.elementId : this.props.match.params.elementId) +
              '.json'
            }
            data={data}
          />
          <FormErrors formStatus={formStatus} />

          <form method="put" onSubmit={this.formSubmit} key={entityLoaded ? entity.getId() : 1}>
            {this.getBreadcrumb()}

            <Row>
              <Col xs={12}>
                <div class="text-right m-b-10">
                  <Button
                    bsSize="lg"
                    disabled={formStatus.pending}
                    type="submit"
                    bsStyle={this.state.entityChanged ? 'primary' : 'default'}
                  >
                    <i class={'fa-fw ' + (formStatus.pending ? ' fa fa-circle-notch fa-spin' : 'fal fa-save')} />{' '}
                    {messages.save}
                  </Button>
                </div>
              </Col>
            </Row>

            <Row>
              <Col xs={12}>
                <Tabs
                  tabs={this.getTabHeaderList()}
                  tabContent={this.getTabContentList()}
                  keepMounted={this.getTabKeepMounted()}
                />
              </Col>
            </Row>
          </form>
        </div>
      </DocMeta>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    data: state.data.cmsElement,
    formStatus: state.formStatus.cmsElementEdit,
    meta: state.entityMeta,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
    onSubmit: (elementId, args) => {
      formStatusDispatchHelper('cmsElementEdit', '/api/dynamicelements/' + elementId + '.json', args, 'put', dispatch);
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CmsElementDetails)
);
